import { useEffect } from "react";
import T from "prop-types";
import { parse } from "query-string";

const PaginationController = ({ limit, search, dispatch }) => {
  useEffect(() => {
    const { page } = parse(location.search);
    dispatch(search.setLimit(limit));
    if (page !== undefined) {
      dispatch(search.setPage(page));
    }
  }, []);

  return null;
};

PaginationController.propTypes = {
  limit: T.number,
  search: T.shape({
    pageActions: T.shape({
      reload: T.func
    })
  }).isRequired,
  dispatch: T.func.isRequired
};

PaginationController.defaultProps = {
  limit: 15
};

export default PaginationController;



// WEBPACK FOOTER //
// ./app/modules/Notifications/components/Search/PaginationController.jsx